import { combineReducers } from 'redux';
import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { updateableReducer } from './common';

const usersMeReducerFactyory = (actionType) => {
    switch (actionType) {
        case types.CURRENT_USER_UPDATED:
            return (stateValue, actionValue) => {
                return { 
                    ...stateValue, 
                    value: actionValue
                };
            };

        default:
            return null;
    }
};

export default combineReducers({
    me: updateableReducer(usersMeReducerFactyory, initialState.users.me)
});



// WEBPACK FOOTER //
// ./src/js/reducers/usersReducer.js